(function($) {
  Drupal.behaviors.aerin_section = {
    attach: function(context, settings) {
      $('body').addClass('brand-aerin');
    }
  };
})(jQuery);
